import BaseList from "./src";
import type { App } from "vue";
BaseList.install = function (Vue: App): void {
  console.info("BaseList----install----");
  Vue.component(BaseList.name, BaseList);
};

export default BaseList;
